import { render, staticRenderFns } from "./serveTab1.vue?vue&type=template&id=1c318bb2&scoped=true"
import script from "./serveTab1.vue?vue&type=script&lang=js"
export * from "./serveTab1.vue?vue&type=script&lang=js"
import style0 from "./serveTab1.vue?vue&type=style&index=0&id=1c318bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c318bb2",
  null
  
)

export default component.exports